<template>
  <span
    :contenteditable="!readonly"
    ref="editable"
    class="editable"
    @input="update"
    @blur="$emit('blur', $event)"
  ></span>
</template>

<script>
export default {
  name: "editable",

  props: {
    value: undefined,
    readonly: Boolean
  },

  data() {
    return {
      emitAfterOnUpdate: false
    };
  },

  mounted() {
    this.$el.innerText = this.value;
  },

  methods: {
    focus() {
      this.$refs.editable.focus();
    },

    update(event) {
      this.emitAfterOnUpdate = true;
      this.$emit("input", event.target.innerText);
    }
  },

  watch: {
    value(value) {
      if (this.emitAfterOnUpdate) {
        this.emitAfterOnUpdate = false;
        return;
      }

      this.$el.innerText = value;
    }
  }
};
</script>

<style lang="scss" scoped>
.editable {
  cursor: text;
}

.editable:empty::before {
  content: attr(placeholder);
  opacity: 0.5;
}
</style>
